import React from 'react';
import {Formik, Field, FormikProps} from 'formik';

import {Layouts, Form, Button} from '@components';
import validations from '@validations';
import {Props} from './types';
import * as handlers from './handlers';

import './index.scss';

const Confirm: React.FC<Props> = props => {
  const initialValues = {code: ''};
  return (
    <div className="a__confirm">
      <Layouts.Header.Before
        history={props.history}
        location={props.location}
        match={props.match}
      />
      <div className="w__message">
        <div className="b__title">認証コード入力</div>
        <div className="b__message">
          メールに記載されている6桁の認証コードを入力してください。
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={(value: any, formikAction: any) => {
            handlers.confirmCode(value, formikAction, props);
          }}
          validate={validations.signUp.confirm}
        >
          {(formProps: FormikProps<any>) => {
            return (
              <div className="w__field">
                <Field
                  component={Form.Input}
                  name="code"
                  placeholder="認証コードを入力してください"
                  maxLength={6}
                />
                <div className="w__button">
                  <Button.Normal
                    color="yellow"
                    text="送信する"
                    rounded
                    disabled={formProps.isSubmitting}
                    loading={formProps.isSubmitting}
                    className="b__submit-button"
                    onClick={() => {
                      formProps.handleSubmit();
                    }}
                  />
                </div>
              </div>
            );
          }}
        </Formik>
        {/* <SemanticButton className="b__link">
          認証コードを再送信する
        </SemanticButton> */}
      </div>
      <Layouts.Footer.Main />
    </div>
  );
};
export default Confirm;
